import { Helmet } from "react-helmet"
import { MetaSettings } from "./metaSettings"
import React from "react";

interface Props{
  path:string
}
const MetaTags: React.FC<Props> = (props) => {
  const title = props.path === '/' 
    ? 'Tennis.ru - Фитнес-клуб'
    : `Tennis.ru - Фитнес-клуб - ${MetaSettings[props.path as keyof typeof MetaSettings]?.title || ''}`;

  return(
    // @ts-expect-error
    <Helmet>
      {/* @ts-expect-error */}
      <title>{title}</title>
    </Helmet>
  )
}
export default MetaTags
